

<template class="bg-white">
  <quill-editor
    class="quill-editor mb-16 mt-2 bg-white"
    style="height: 500px"
    ref="editor"
    v-model="editor.data"
    :options="editor.options"
    @change="({ quill, html, text }) => $emit('change', html)"
  />
</template>


<script>
import Quill from "quill";

import ImageResize from "quill-image-resize-module";
import VideoResize from "quill-video-resize-module";
import QuillImageDropAndPaste from "quill-image-drop-and-paste";

import { storage } from "@/firebase.js";

Quill.register("modules/imageDropAndPaste", QuillImageDropAndPaste);
Quill.register("modules/videoResize", VideoResize);
Quill.register("modules/imageResize", ImageResize);

export default {
  props: {
    content: {
      type: String,
    },
  },
  data() {
    return {
      editor: {
        options: {
          modules: {
            imageResize: true,
            videoResize: true,
            imageDropAndPaste: {
              handler: async (imageDataUrl, type, imageData) => {
                const quill = this.$refs.editor.quill;

                const filename = new Date().getTime();
                const extension = type.split("/")[1];

                const file = imageData.toFile(filename);

                await this.upload(file, quill);
              },
            },
            toolbar: {
              container: [
                [{ font: [] }, { size: [] }],
                ["bold", "italic", "underline", "strike"],
                [{ color: [] }, { background: [] }],
                [{ script: "super" }, { script: "sub" }],
                [{ header: "1" }, { header: "2" }, "blockquote", "code-block"],
                [
                  { list: "ordered" },
                  { list: "bullet" },
                  { indent: "-1" },
                  { indent: "+1" },
                ],
                ["direction", { align: [] }],
                ["image", "video"],
              ],
              handlers: {
                image: () => {
                  const quill = this.$refs.editor.quill;

                  const input = document.createElement("input");

                  input.setAttribute("type", "file");
                  input.setAttribute("accept", "image/*");
                  input.click();

                  input.onchange = async () => {
                    const file = input.files[0];

                    await this.upload(file, quill);
                  };
                },
              },
            },
          },
        },
        data: "",
      },
    };
  },
  watch: {
    content(value) {
      this.editor.data = value;
    },
  },
  methods: {
    async upload(file, quill) {
      const filename = new Date().getTime();
      const extension = file.name.split(".").pop();
      const range = quill.getSelection(true);

      quill.insertEmbed(
        range.index,
        "image",
        "https://cdn.dribbble.com/users/1341307/screenshots/5377324/morph_dribbble.gif"
      );

      const ref = storage.ref(`editor/images/${filename}.${extension}`);

      try {
        const snapshot = await ref.put(file);
        const downloadURL = await snapshot.ref.getDownloadURL();

        quill.deleteText(range.index, 1);
        quill.insertEmbed(range.index, "image", downloadURL);
        quill.setSelection(range.index + 1);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
.quill-editor iframe {
  pointer-events: none;
}
</style>